import React from 'react'
import { Paper, TableBody, TableCell, TableRow, Tooltip } from '@material-ui/core'
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment'
import { displayDateFormat } from '../../../../constants'
import { showCurrencyFormat } from '../../../../utils'
import { EmptyCollection, TableListComp } from '../../../../shared_elements'
import { Info } from '@material-ui/icons';
const reserveHd =(item)=>{
  return(
    item?.reserve_accounts && Object.keys(item?.reserve_accounts).length > 0 ?
    [
      { label: "Transaction Type" },
      { label: "Invoice Number" },
      { label: "Invoice Date" },
      { label: "Invoice Amount" },
      { label: "Cashflow Entry" },
      { label: "Total" },
      ...Object.keys(item?.reserve_accounts)?.map(account => ({ label: account }))
    ]:
    []
  )
}
const ReserveList = ({item, params}) => {
  return (
    <TableRow className='cshflw-crd-bdy-row'>
      <TableCell>
        <div style={{ fontFamily: 'Conv_IBMPlexSans-medium' }}>{item?.transaction_type_name || '---'}</div>
        {item?.is_partial? <div>(Partial Payment)</div>:null}
      </TableCell>
      <TableCell>
      {item?.invoice_id?
          <p onClick={()=>{window.open(`invoice/view/${item?.invoice_id}`,'_blank')}}>{item?.invoice_number || '--'}</p>:
          '--'}</TableCell>
      <TableCell>{item?.invoice_date ? moment(item?.invoice_date).format(displayDateFormat) : '--'}</TableCell>
      <TableCell style={{color:item?.is_negative? 'red' : 'black'}}>
        <NumericLabel params={showCurrencyFormat()}>
          {item.invoice_amount || 0}
        </NumericLabel>  &nbsp;
        {item?.invoice_excess_amount?
            <Tooltip title={`Excess Amount: US$${item?.invoice_excess_amount}`} arrow>
              <Info style={{ fontSize: '15px' }} />
            </Tooltip>:null}
      </TableCell>
      <TableCell>{item?.cashflow_entry ? moment(item?.cashflow_entry).format(displayDateFormat) : '--'}</TableCell>
      <TableCell>
        <NumericLabel params={showCurrencyFormat()}>
          {item.total ||0}
        </NumericLabel>
      </TableCell>
      {item?.reserve_accounts && Object.keys(item?.reserve_accounts).length > 0 ?
        Object.keys(item?.reserve_accounts).map((account, index) => (
          <TableCell key={index}>
            {item?.reserve_accounts[account]?.amount && item?.reserve_accounts[account]?.amount !=='--' ?
            <>
              <NumericLabel params={showCurrencyFormat()}>
              {item?.reserve_accounts[account]?.amount || 0}
            </NumericLabel> &nbsp;
            {item?.reserve_accounts[account]?.excess_amount?
            <Tooltip title={`Excess Amount: US$${item?.reserve_accounts[account]?.excess_amount}`} arrow>
              <Info style={{ fontSize: '15px' }} />
            </Tooltip>:null}
            </>
            :'--'}
          </TableCell>
        )) : <TableCell>--</TableCell>
      }
    </TableRow>
  )
}
export default function ReserveCard({data, params}) {
  let reserveHeaders = reserveHd(data?.items[0]);
  return (
    <div className="cshflw-crd">
      <div className="cshflw-crd-hdr">
        <h5>Reserve</h5>
        <div>Total Balance:&nbsp;
        <b> <NumericLabel params={showCurrencyFormat()}>
          {data.total ||0}
        </NumericLabel>
        </b>
        </div>
      </div>
      <div className="cshflw-crd-bdy">
        <TableListComp
          xScroll={true}
          maxheight={'max-content'}
          heads={reserveHeaders}
          data={data?.items?.map((item, index) =>
            (<ReserveList
              params={params}
              key={index}
              item={item}
            />)
          )}
          noRecord={data?.items?.length ? null :
            <EmptyCollection
              title="No records found"
            />
          }
        />
      </div>
    </div>
  )
}
